import { render } from "./NaveProdMobile.vue?vue&type=template&id=61e694b0&scoped=true"
import script from "./NaveProdMobile.vue?vue&type=script&lang=js"
export * from "./NaveProdMobile.vue?vue&type=script&lang=js"

import "./NaveProdMobile.vue?vue&type=style&index=0&id=61e694b0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61e694b0"]])

export default __exports__